import { render, staticRenderFns } from "./CenterAcquisitionStatistics.vue?vue&type=template&id=32d3764c&scoped=true"
import script from "./CenterAcquisitionStatistics.vue?vue&type=script&lang=js"
export * from "./CenterAcquisitionStatistics.vue?vue&type=script&lang=js"
import style0 from "./CenterAcquisitionStatistics.vue?vue&type=style&index=0&id=32d3764c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3764c",
  null
  
)

export default component.exports